
export function GetCookieInfo(name) {
    const cookieString = document.cookie;
    const cookies = cookieString.split(';');

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();

        if (cookie.startsWith(`${name}=`)) {
            const cookieParts = cookie.split('=');
            const value = cookieParts[1];

            // Извлекаем значение истечения срока действия куки
            let expires = null;
            const cookieAttributes = cookieParts[0].split(';');
            for (let j = 0; j < cookieAttributes.length; j++) {
                const attribute = cookieAttributes[j].trim();
                if (attribute.startsWith('expires=')) {
                    expires = attribute.substring('expires='.length);
                    break;
                }
            }

            return { value, expires };
        }
    }

    return null;
}
export const ClearCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const SaveSessionCookie = (name, value) => {
    document.cookie = `${name}=${value}; path=/;`;
    console.log('Saved session cookie ' + name + ' : ' + value);
};